<template>
  <FieldValidator :name="name">
    <template v-slot="{ value, handleChange, isInvalid, errorMessage }">
      <!-- @vue-expect-error FIXME: value not assignable to type 'String[]' -->
      <Chips
        :modelValue="value"
        @update:modelValue="handleChange"
        :class="{ 'p-invalid': isInvalid }"
        v-bind="$attrs"
        ref="chips"
      >
        <template v-if="label" #label>{{ label }}</template>
        <template v-if="isInvalid" #helperText>{{ errorMessage }}</template>
      </Chips>
    </template>
  </FieldValidator>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { Chips } from './../../../core/controls/chips';
import { FieldValidator } from './../field-validator';

// Define options
defineOptions({
  name: 'ChipsField',
  inheritAttrs: false,
});

defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
});

const chips = ref<InstanceType<typeof Chips>>();

defineExpose({ chips });
</script>
